import React from 'react';

const PopupMessage = ({ popupMessageString, onClose }) => {
  //console.log('cm ' + popupMessageString);
  return (
    <div className="popup-background">
    <div className="popup">
        <div className="popup-content ">
          <div className="arcMsgBox-caption">Hinweis:</div>
        <p>{popupMessageString} </p>
        <button className="arcMsgBox-button" onClick={onClose}>OK</button>
      </div>
    </div>
    </div>
  );
};

export default PopupMessage;
